import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { AssetCategoryDepreciationConfigModel } from '../../../../../../models/aggregates/erp/asset-register';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class AssetCategoryDepreciationConfigService extends BaseApiTemplateService<AssetCategoryDepreciationConfigModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/category-depreciation-configs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/category-depreciation-configs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'fa/category-depreciation-configs/backoffice-ep';
    this.httpClient = http;
  }

}
